// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"

Rails.start()
Turbolinks.start()
ActiveStorage.start()

import "bootstrap"
import "tempusdominus-bootstrap-4"

import "@fortawesome/fontawesome-free/js/all.min"

import "../src/tinymce"
import "../src/assign_booths.js.erb"
import "../src/booths.js.erb"
import "../src/copy_move_selector.js.erb"
import "../src/datetime_pickers"
import "../src/recaptcha.js.erb"
import "../src/vendors.js.erb"
import "../src/lightbox"

// make JQuery available to view templates
import jQuery from "jquery"
global.$ = global.jQuery = jQuery;
window.$ = window.jQuery = jQuery;
